import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import { sentryLogException } from '@core/helpers/sentryLogger';
import * as MutationTypes from './mutationTypes';

const menuSuccess = (state, payload) => {
  state.currentMenu = payload;
};

const sectionSuccess = (state, { section, sectionList }) => {
  state.currentSection = section;
  state.currentSectionList = sectionList;
  if (section && !state.sectionCache.find((s) => s.guid === section.guid)) state.sectionCache.push(section);
};

const breadcrumbSuccess = (state, { parentClause, parentSection }) => {
  state.parentClause = parentClause;
  state.parentSection = parentSection;
  if (parentClause && !state.sectionCache.find((e) => e.guid === parentClause.guid)) {
    state.sectionCache.push(parentClause);
  }
  if (parentSection && !state.sectionCache.find((e) => e.guid === parentSection.guid)) {
    state.sectionCache.push(parentSection);
  }
};

const createSection = (state, section) => {
  state.currentSectionList.push(section);
};

const editSection = (state, { section, parent }) => {
  try {
    state.currentSectionList = state.currentSectionList.map((sec) => (sec.guid === section.guid ? sec.overwrite(section) : sec));
    state.sectionCache = state.sectionCache.map((sec) => (sec.guid === section.guid ? sec.overwrite(section) : sec));
    parent.sections = parent.sections.map((sec) => (sec.guid === section.guid ? sec.overwrite(section) : sec));
  } catch (err) {
    sentryLogException(err, `Error in mutation 'editSection', menu: ${parent ? parent?.menu : section?.menu}, parent: ${parent}, section: ${section?.guid}`);
  }
};

const editMenu = (state, menu) => {
  state.currentMenu = menu;
};

const editTheme = (state, theme) => {
  state.currentMenu.theme = theme.guid;
};

const deleteSection = (state, { section, parent }) => {
  state.currentSectionList = state.currentSectionList.filter((sec) => sec.guid !== section.guid);
  state.sectionCache = state.sectionCache.filter((sec) => sec.guid !== section.guid);
  parent.sections = parent.sections.filter((sec) => sec.guid !== section.guid);
};

const resetMenuEditor = (state) => {
  state.currentSectionList = [];
  state.currentSection = null;
  state.sectionCache = [];
};

const createProduct = (state, product) => {
  state.currentSection.products.push(product);
};

const editProduct = (state, product) => {
  state.currentSection.products = state.currentSection.products.map((oldP) => (oldP.guid === product.guid ? product : oldP));
};

const deleteProduct = (state, product) => {
  state.currentSection.products = state.currentSection.products.filter((itm) => itm.guid !== product.guid);
};

const moveItem = (state, { itemOne, itemTwo }) => {
  [itemOne.order, itemTwo.order] = [itemTwo.order, itemOne.order];
};

const reorderItems = (state, itemList) => {
  itemList.forEach((el, index) => {
    el.order = index;
  });
};

// Used after item is deleted inside a section to move other items up
const reorderSectionContents = (state, { section, order }) => {
  section.sections.forEach((el) => {
    if (el.order > order) {
      el.order -= 1;
    }
  });
  section.products.forEach((el) => {
    if (el.default_order > order) {
      el.default_order -= 1;
    }
  });
};

const resetPointOfSaleData = (state) => {
  state.currentMenu = undefined;
  state.currentSection = undefined;
  state.currentSectionList = [];
  state.sectionCache = [];
  state.parentClause = undefined;
  state.parentSection = undefined;
};

export const mutations = {
  [MutationTypes.MENU_SUCCESS]: menuSuccess,
  [MutationTypes.SECTION_SUCCESS]: sectionSuccess,
  [MutationTypes.BREADCRUMB_SUCCESS]: breadcrumbSuccess,
  [MutationTypes.CREATE_SECTION]: createSection,
  [MutationTypes.EDIT_SECTION]: editSection,
  [MutationTypes.DELETE_SECTION]: deleteSection,
  [MutationTypes.RESET_MENU_EDITOR]: resetMenuEditor,
  [MutationTypes.CREATE_PRODUCT]: createProduct,
  [MutationTypes.EDIT_PRODUCT]: editProduct,
  [MutationTypes.DELETE_PRODUCT]: deleteProduct,
  [MutationTypes.MOVE_ITEM]: moveItem,
  [MutationTypes.REORDER_ITEMS]: reorderItems,
  [MutationTypes.REORDER_SECTION_CONTENTS]: reorderSectionContents,
  [MutationTypes.EDIT_MENU]: editMenu,
  [MutationTypes.EDIT_THEME]: editTheme,
  [RESET_POINT_OF_SALE_STATE]: resetPointOfSaleData
};
